let language = {
    CHECKOUT_PAYMENT_PRODUCTS:"Products",
    CHECKOUT_PAYMENT_IMPORT_SERVICE: "Import Service",
    CHECKOUT_PAYMENT_QTY:"Quantity",
    CHECKOUT_PAYMENT_UNITED_PRICE:"United Price",
    CHECKOUT_PAYMENT_PRICE:"Price",
    CHECKOUT_PAYMENT_PREVIEW:"PREVIEW",
    CHECKOUT_PAYMENT_PROJECT_NAME:"Name :",
    CHECKOUT_PAYMENT_TAX:"Tax:",
    CHECKOUT_PAYMENT_SHIPPING:"Shipping:",
    CHECKOUT_PAYMENT_TOTAL_DUE:"Total Due:",
    CHECKOUT_PAYMENT_TOTAL:"Total Due:",
    CHECKOUT_PAYMENT_PAYMENT_METHOD:"Payment Method:",
    CHECKOUT_PAYMENT_APPROVENOSECRET_DES:"Add this primary billing method for your {{website}} account. It'll be the default we use to charge you for future transactions.",
    CHECKOUT_PAYMENT_PAYPAL_DES:"PayPal accepts all major credit cards. You do not need a Paypal account to use this payment method.",
    CHECKOUT_PAYMENT_BANK_TRANSFER_DES:"To pay, click \"{{payBtnText}}\" and follow the transfer instructions.",
    CHECKOUT_PAYMENT_BACK_BTN:"BACK",
    CHECKOUT_PAYMENT_BACK_PAYMENT:"PAYMENT",
    CHECKOUT_PAYMENT_CONFIRM_AND_PAY_BTN:"CONFIRM AND PAY",
    CHECKOUT_PAYMENT_COPYRIGHT_TIP:"I agree to my data being processed in accordance with",

    // 订单支付方式不支持--提示
    CHECKOUT_PAYMENT_FAILED:"Payment unsuccessful",
    CHECKOUT_PAYMENT_FAILED_DES1:"We currently do not support this payment method. Please choose another payment option and try again, or you can contact our technical support at {{supportmail}} to fix this problem.",
    // 产品不支持预览提示
    CHECKOUT_PREVIEW_ISSUE_TITLE:"Currently not supported",
    CHECKOUT_PREVIEW_ISSUE_CONTENT:"The uncustomized products do not support preview for the time being.",
    // paypal重定向失败
    CHECKOUT_PAYMENT_ISSUE_TITLE:"PayPal redirection failed",
    CHECKOUT_PAYMENT_ISSUE_CONTENT:"Opps, payPal payment redirection failed, Please to try again later.",
}


export { language }